import VoteFormReducer from 'store/widgets/VoteForm/reducers';

import { convertWidgetData } from './dataConverter';

export default [VoteFormReducer, convertWidgetData];
